import React from 'react';

import DataTable from 'components/DataTable';
import Typography from 'components/Typography';

import { TOTAL } from './constants';
import { useColumns } from './useColumns';

export default ({ data = [] }: any) => {
  const rows = data.filter((el: any) => el.application?.name !== TOTAL);
  const footer = data.filter((el: any) => el.application?.name === TOTAL)?.[0];
  const columns = useColumns({ footer });

  return (
    <>
      <DataTable
        data={rows}
        columns={columns}
        showFooter={true}
        fullWidth={true}
      />
      <Typography
        variant={'caption'}
        color={'medium-shade'}
        className={'padding'}
      >
        UA / RE / Total rejected installs by post-attribution fraud had been
        attributed to the affiliate, however they were reported as fraud.
      </Typography>
    </>
  );
};
